<template>
	<ui-box v-if="shouldShowSection('advanced') && shouldShowSection('settings')">
		<h5>Advanced Settings</h5>
		<span class="grey--text text--darken-1 text-body-2">
					</span>

		<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

		<!-- Add Available for Purchase Date Range -->

		<v-row>
			<v-col>
				<span class="grey--text text--darken-1 text-body-2">
					Adding dates will allow the item card to automatically appear or disappear on your website.
				</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-btn
						class="mb-6 ms-2 mt-2 rounded-lg"
						color="info"
						depressed
						@click="showAddAvailableDateRangeForm = true"
				>
					<v-icon>
						mdi-plus
					</v-icon>
					Add Available for Purchase Date Range
				</v-btn>
			</v-col>
		</v-row>

		<template v-if="showAddAvailableDateRangeForm">
			<ui-box>
				<v-row>

					<!-- Add Start Date Time -->
					<v-col cols="12" sm="6">
						<bw-date-time-picker
								v-model="newAvailableDateRange.start_date"
								label="Start Date & Time"
								withTime
						></bw-date-time-picker>
					</v-col>
					<!-- End: Add Start Date Time -->

					<!-- Add End Date Time -->
					<v-col cols="12" sm="6">
						<bw-date-time-picker
								v-model="newAvailableDateRange.end_date"
								label="Start Date & Time"
								withTime
						></bw-date-time-picker>
					</v-col>
					<!-- End: End Start Date Time -->
				</v-row>

				<v-row>
					<v-col>
						<v-btn
								class="me-2 me-md-4 rounded-lg"
								color="grey darken-1"
								depressed
								text
								@click="hideAndCleanAvailableDateRange"
						>
							Cancel
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:disabled="newAvailableDateRange.start_date == null && newAvailableDateRange.end_date == null"
								@click="saveAvailableDateRange"
						>
							Add
						</v-btn>
					</v-col>
				</v-row>

			</ui-box>

		</template>
		<!-- End: Add Available for Purchase Date Range -->


		<!-- Available for Purchade Date Range List -->
		<template v-if="newPass.active_dates?.length > 0"
							v-for="(date, index) in newPass.active_dates">
			<ui-box>
				<v-row>
					<v-col cols="12" sm="4">
						<v-text-field
								:value="getDisplayLocalDateTime(date.start_date)"
								append-icon="mdi-calendar"
								class="rounded-lg"
								:dense="$vuetify.breakpoint.smAndDown"
								hide-details
								label="Start Date & Time"
								outlined
								readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<v-text-field
								:value="getDisplayLocalDateTime(date.end_date)"
								append-icon="mdi-calendar"
								class="rounded-lg"
								:dense="$vuetify.breakpoint.smAndDown"
								hide-details
								label="End Date & Time"
								outlined
								readonly
						></v-text-field>
					</v-col>
					<v-col cols="12" sm="4">
						<v-btn color="bw-warning"
									 class="mb-6 ms-2 mt-2 rounded-lg"
									 depressed
									 @click="removeAvailableDateRange(index)"
						>
							<v-icon>mdi-trash-can-outline</v-icon>
							Remove
						</v-btn>
					</v-col>
				</v-row>
			</ui-box>

		</template>
		<!-- End: Available for Purchade Date Range List -->

		<v-divider class="mb-6 mt-4 opacity-80"></v-divider>

		<!-- Max Redemptions -->
		<v-row>
			<v-col>
				<v-text-field
						v-model.number="newPass.max_product_redemptions"
						class="rounded-lg"
						hint='This is the total number of redemptions that can occur on a pass. Once the customer hits this number, the pass will be completed.'
						label="Max Redemptions"
						min="0"
						outlined
						persistent-hint
						type="number"
						@wheel.native.prevent
				></v-text-field>
			</v-col>
		</v-row>
		<!-- End: Max Redemptions -->


	</ui-box>

</template>

<script>
import { helpers } from '../../../helpers';

export default {
	name: "PassSettingsSection",
	props: {
		newPass: {
			type: Object,
			required: true,
		},
		rules: {
			type: Object,
			required: true,
		},
		showSections: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			showAddAvailableDateRangeForm: false,
			newAvailableDateRange: new AvailableDateRange(),
		}
	},
	methods: {
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
		saveAvailableDateRange() {
			if(!this.newPass.active_dates) this.$set(this.newPass, 'active_dates', []);
			this.newPass.active_dates.push(this.newAvailableDateRange);

			this.hideAndCleanAvailableDateRange();
		},
		hideAndCleanAvailableDateRange() {
			this.showAddAvailableDateRangeForm = false;
			this.newAvailableDateRange = new AvailableDateRange();
		},
		removeAvailableDateRange(index) {
			this.newPass.active_dates.splice(index, 1);
		},
		getDisplayLocalDateTime(dateTime) {
			return helpers.getDisplayLocalDateTime(dateTime);
		},
	}
}

function AvailableDateRange() {
	this.start_date = null;
	this.end_date = null;
}

</script>